import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';

import { analyticsApi, type EventListParams } from '../api/analytics-api';

import { analyticsKeys } from './analytics-keys';

/** Shared by the route loader (prefetch) and the page hook (subscribe). */
export function analyticsEventsQueryOptions(storeId: string, params: EventListParams) {
  return queryOptions({
    queryKey: analyticsKeys.events(storeId, params),
    queryFn: () => analyticsApi.events(storeId, params),
    placeholderData: keepPreviousData,
  });
}

export function useAnalyticsEvents(storeId: string, params: EventListParams) {
  return useQuery(analyticsEventsQueryOptions(storeId, params));
}
